import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'guidFormat',
  standalone: false,
})
export class GuidFormatPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value || value.length !== 16) {
      return value ?? '';
    }
    return `${value.slice(0, 4)}-${value.slice(4, 8)}-${value.slice(8, 12)}-${value.slice(12, 16)}`;
  }
}
